import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { networkDuelGroupMove, networkRemoveDuel, useFetchDuelList } from 'src/network/duels';
import { useQueryClient } from '@tanstack/react-query';
import useFormsModalStore from 'src/store/forms';
import { APP_DUAL_LIST, APP_MEDIA_REWARDS_LIST } from 'src/constants/queryKeys';
import { reorderList } from 'src/utils';
import { networkGetMediaRewardsRemove, useFetchMediaRewards } from 'src/network/mediaRewars';

export const useMediaRewards = (params) => {
  const { page, projectId, selected, setSelected, filterItems } = params;

  const { setModal, modal } = useFormsModalStore();

  const { enqueueSnackbar } = useSnackbar();

  const queryClient = useQueryClient();

  const [, setSavedPage] = useLocalStorage('savedPage');

  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);

  const [deleteLoading, setDeleteLoading] = useState(false);

  const [tableData, setTableData] = useState([]);
  const [originalTableData, setOriginalTableData] = useState([]);

  const [isDraggable, setIsDraggable] = useState(false);
  const [sortLoading, setSortLoading] = useState(false);

  // ---------------------------------------------------------------------------------

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = reorderList(tableData, result.source.index, result.destination.index);
    setTableData(items);
  };

  const handleSortList = () => {
    const duelIDs = tableData?.map((item, index) => item.DuelID);
    const indexs = tableData?.map((item, index) => index).reverse();
    const newArray = [];
    for (let i = 0; i < duelIDs?.length; i++) {
      newArray.push({ DuelID: duelIDs[i], Index: indexs[i] });
    }
    setSortLoading(true);
    networkDuelGroupMove(projectId, newArray)
      .then((res) => {
        enqueueSnackbar('تفییرات با موفقیت اعمال شد');
        queryClient.invalidateQueries({ queryKey: [APP_DUAL_LIST, projectId] });
        setIsDraggable(false);
      })
      .catch((error) => console.log(error))
      .finally(() => setSortLoading(false));
  };

  const resetDragAndDrop = () => setTableData(originalTableData);

  // ---------------------------------------------------------------------------------

  const handleDeleteRow = (id) => {
    setDeleteLoading(true);
    networkGetMediaRewardsRemove(id)
      .then((res) => {
        const deleteRow = tableData.filter((row) => row.MediaRewardsID !== id);
        setTableData(deleteRow);
        enqueueSnackbar('تورنومنت موردنظر با موفقیت حذف شد');
        const newSelectedItems = selected?.filter((id) => id !== id);
        setSelected(newSelectedItems);
        queryClient.invalidateQueries({ queryKey: [APP_DUAL_LIST, projectId] });
      })
      .catch((error) => console.log(error))
      .finally(() => {
        setOpenConfirmDelete(false);
        setDeleteLoading(false);
      });
  };

  const handleEditRow = (Info) => {
    setModal({
      data: Info,
      isOpen: true,
      MediaRewardsID: Info?.MediaRewardsID,
      type: APP_MEDIA_REWARDS_LIST,
      isEdit: true,
      title: 'ویرایش پاداش',
    });
  };

  const { isLoading, isFetching, data, refetch } = useFetchMediaRewards(projectId);

  useEffect(() => {
    if (data && projectId) {
      const dataItems = data?.data?.items || [];
      setTableData([...dataItems]);
      setOriginalTableData([...dataItems]);
    }
  }, [data, projectId]);

  useEffect(() => {
    if (!modal?.isOpen) refetch();
  }, [modal]);

  return {
    tableData,
    isLoading: isLoading || isFetching,
    isFetching,
    deleteLoading,
    handleDeleteRow,
    handleEditRow,
    openConfirmDelete,
    setOpenConfirmDelete,
    isDraggable,
    sortLoading,
    setIsDraggable,
    onDragEnd,
    handleSortList,
    resetDragAndDrop,
  };
};
